import * as React from 'react';
import {StatelessComponent} from 'react';
import {
  ConfirmModal,
  ConfirmModalContent as Content,
} from '../../confirm-modal';
import {Text} from '../../text/text';

import './styles.sass';

export interface ISessionRunTestsAlertProps {
  isOpen: boolean;
  onClose: (confirmed?: boolean) => void;
}

export const SessionRunTestsConfirm: StatelessComponent<ISessionRunTestsAlertProps>
  = ({isOpen, onClose}: ISessionRunTestsAlertProps) => (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      title={'Unlock Test Evaluation'}
      leftButtonText={'No Yet...'}
      rightButtonText={'I\'m Ready! Test My Code!'}
    >
      <Content className={'session-run-tests-confirm'}>
        <Text>
          In a real interview, you won't always have this option.
          To help you prepare, we recommend that you evaluate your code only after you feel that your solution is complete and correct.
        </Text>

        <Text className={'session-run-tests-confirm__question'}>
          Are you sure you're ready to test your solution?
        </Text>
      </Content>
    </ConfirmModal>
  );
